import { createSlice, Slice } from '@reduxjs/toolkit'

import { OrgUsersById } from 'context/orgUsersContext'

export interface OrgUsersByIdState extends Partial<OrgUsersById> {
  loaded: boolean
  users: OrgUsersById
}

const initialState: OrgUsersByIdState = {
  loaded: false,
  users: {}
}

export const orgUsersByIdSlice: Slice<OrgUsersByIdState> = createSlice({
  name: 'orgUsersById',
  initialState,
  reducers: {
    setOrgUsersById: (state, { payload }) => ({
      ...state,
      users: payload,
      loaded: true
    })
  }
})

const { reducer: OrgUsersByIdReducer, actions } = orgUsersByIdSlice

export const { setOrgUsersById } = actions

export default OrgUsersByIdReducer
